import { render, staticRenderFns } from "./c-storages-field.vue?vue&type=template&id=41570f20&"
import script from "./c-storages-field.vue?vue&type=script&lang=js&"
export * from "./c-storages-field.vue?vue&type=script&lang=js&"
import style0 from "./c-storages-field.vue?vue&type=style&index=0&id=41570f20&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports